import { useState, useEffect } from 'react';

export const brandColors = {
  primary: '#2F4632',
  secondary: '#A8C3A0',
  accent: '#F2C98D',
  success: '#10B981',
  warning: '#F59E0B',
  danger: '#EF4444',
  info: '#3B82F6',
  purple: '#8B5CF6',
  teal: '#14B8A6',
  pink: '#EC4899',
  orange: '#F97316',
  slate: '#64748B',
};

export const AnimatedCounter = ({ value, duration = 800, suffix = '' }) => {
  const [displayValue, setDisplayValue] = useState(0);
  
  useEffect(() => {
    let startTime;
    const endValue = typeof value === 'number' ? value : parseInt(value) || 0;
    
    const animate = (currentTime) => {
      if (!startTime) startTime = currentTime;
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easeOut = 1 - Math.pow(1 - progress, 3);
      setDisplayValue(Math.round(endValue * easeOut));
      if (progress < 1) requestAnimationFrame(animate);
    };
    
    requestAnimationFrame(animate);
  }, [value, duration]);
  
  return <>{displayValue}{suffix}</>;
};
